// @flow

import { type UserInputValidationError, VALID } from '@tectonics/prs/validation';

export function validatePeruvianState(stateValue: string): ?UserInputValidationError {
  return stateValue ? VALID : { id: 'empty' };
}
